/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { v4 as uuidv4 } from 'uuid';
import { getDefaultVehicleColor } from 'jotai/vehicleColor';
import { CompetitorGroupVehicle } from './CompetitorGroupObject';

export const getCompetitorGroupVehicleDefault = (
  id?: string,
  vehicleNumber = '',
  highlighted = false,
  seriesId?: string
): CompetitorGroupVehicle => {
  const colorId = vehicleNumber ? getDefaultVehicleColor(vehicleNumber, seriesId).id : '';
  return { id: id || uuidv4(), vehicleNumber, colorId, highlighted, seriesId };
};
